import React from "react";
import zoopersLogo from "../../assets/logo_website.png";
import { APP_STORE_URL, PLAY_STORE_URL } from "../../mock";

const InstagramIcon = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
  </svg>
);

export default function Footer() {
  return (
    <footer className="relative bg-[#12121A] text-slate-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div>
          <img
            src={zoopersLogo}
            alt="Zoopers"
            className="h-10 w-auto object-contain brightness-0 invert"
          />
          <p className="mt-5 text-sm leading-relaxed text-slate-400 max-w-xs">
            India's first quick clothing services app. Doorstep tailoring,
            alteration, laundry & ironing.
          </p>
          <div className="mt-5 flex items-center gap-3">
            <a
              href="https://www.instagram.com/zoopers_now?igsh=MWMwM2t3MDBwbnowaQ%3D%3D&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="h-10 w-10 grid place-items-center rounded-full bg-white/5 hover:bg-[#E91E80] hover:text-white text-slate-300 transition-colors">
              <InstagramIcon size={18} />
            </a>
          </div>
        </div>

        {/* Services */}
        <div>
          <h4 className="text-white font-semibold">Services</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {["Tailoring", "Alteration", "Laundry", "Ironing"].map((x) => (
              <li key={x}>
                <a
                  href="#services"
                  className="hover:text-[#FF3E9E] transition-colors">
                  {x}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Company */}
        <div>
          <h4 className="text-white font-semibold">Company</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {[
              { label: "About", href: "#" },
              { label: "How it Works", href: "#how" },
              { label: "Pricing", href: "#pricing" },
              { label: "FAQ", href: "#faq" },
            ].map((x) => (
              <li key={x.label}>
                <a
                  href={x.href}
                  className="hover:text-[#FF3E9E] transition-colors">
                  {x.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Download */}
        <div>
          <h4 className="text-white font-semibold">Get the App</h4>
          <p className="mt-3 text-sm text-slate-400">
            Book, track, and manage your orders right from your phone.
          </p>
          <div className="mt-5 flex flex-col gap-3">
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-white/5 hover:bg-white/10 rounded-xl px-4 py-3 transition-colors border border-white/10">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                <path d="M3.18 23.76a2.07 2.07 0 0 0 .47.24l10.3-10.3-2.97-2.97L3.18 23.76zM20.52 10.4l-2.8-1.6-3.35 3.22 3.35 3.35 2.8-1.62a2.09 2.09 0 0 0 0-3.35zM3 .24a2.09 2.09 0 0 0-.47.24L10.98 9l2.97-2.97L3 .24zM14.25 12 3.65 22.6a2 2 0 0 0 1.2-.2l11.73-6.78-2.33-2.62z" />
              </svg>
              <div>
                <div className="text-[10px] text-slate-400">Get it on</div>
                <div className="text-sm font-semibold text-white">
                  Google Play
                </div>
              </div>
            </a>
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-white/5 hover:bg-white/10 rounded-xl px-4 py-3 transition-colors border border-white/10">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
              <div>
                <div className="text-[10px] text-slate-400">
                  Download on the
                </div>
                <div className="text-sm font-semibold text-white">
                  App Store
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div className="mt-12 max-w-7xl mx-auto px-5 md:px-8 flex flex-col md:flex-row items-center justify-between gap-4 border-t border-white/10 pt-8">
        <p className="text-sm text-slate-500">
          © 2026 Zoopers. All rights reserved.
        </p>
        <div className="flex gap-6 text-sm text-slate-500">
          <a href="#" className="hover:text-white transition-colors">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-white transition-colors">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>
  );
}
